import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <>
      <header className='bg-primary-50 border-b border-secondary-300'>
        <nav className='container mx-auto px-4 py-6 flex justify-between items-center'>
          <div className='flex items-center'>
            <Link
              to='/'
              className='flex items-center hover:text-primary-400 transition-colors duration-200'
            >
              <img
                src='data/images/logo.png'
                alt='Red Panda Treehouse Logo'
                className='h-10 mr-3'
              />
              <div className='text-2xl font-bold text-primary-500'>
                Red Panda Treehouse
              </div>
            </Link>
          </div>

          <div className='hidden md:flex space-x-8 font-medium text-primary-700 dark:text-primary-400'>
            <Link
              to='/'
              className='hover:text-primary-500 dark:hover:text-primary-300'
            >
              Home
            </Link>
            <Link
              to='/members'
              className='hover:text-primary-500 dark:hover:text-primary-300'
            >
              Members
            </Link>
            <Link
              to='/highlight'
              className='hover:text-primary-500 dark:hover:text-primary-300'
            >
              Member Highlight
            </Link>
            <Link
              to='/events'
              className='hover:text-primary-500 dark:hover:text-primary-300'
            >
              Events
            </Link>
            {/* <Link
              to='/special-events'
              className='hover:text-primary-500 dark:hover:text-primary-300 text-death-600 font-bold'
            >
              🐾 Red Panda Day
            </Link> */}
          </div>
          <div className='flex items-center'>
            <button
              onClick={toggleMobileMenu}
              className='md:hidden focus:outline-none ml-4'
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M4 6h16M4 12h16M4 18h16'
                />
              </svg>
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      <div
        className={`mobile-menu fixed top-0 left-0 w-full bg-light-card dark:bg-dark-card py-4 px-6 shadow-lg z-[60] ${
          mobileMenuOpen ? 'open' : ''
        }`}
      >
        <div className='flex justify-between items-center mb-6'>
          <div className='flex items-center'>
            <img
              src='data/images/logo.png'
              alt='Red Panda Treehouse Logo'
              className='h-8 mr-2'
            />
            <div className='text-2xl font-bold text-primary-600 dark:text-primary-500'>
              Red Panda Treehouse
            </div>
          </div>
          <button onClick={toggleMobileMenu} className='focus:outline-none'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='h-6 w-6'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M6 18L18 6M6 6l12 12'
              />
            </svg>
          </button>
        </div>
        <div className='flex flex-col space-y-4 font-medium'>
          <Link
            to='/'
            className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            onClick={toggleMobileMenu}
          >
            Home
          </Link>
          <Link
            to='/members'
            className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            onClick={toggleMobileMenu}
          >
            Members
          </Link>
          <Link
            to='/highlight'
            className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            onClick={toggleMobileMenu}
          >
            Member Highlight
          </Link>
          <Link
            to='/events'
            className='text-primary-700 dark:text-primary-400 hover:text-primary-500 dark:hover:text-primary-300'
            onClick={toggleMobileMenu}
          >
            Events
          </Link>
          {/* <Link
            to='/special-events'
            className='text-death-600 font-bold hover:text-death-500'
            onClick={toggleMobileMenu}
          >
            🐾 Red Panda Day
          </Link> */}
        </div>
      </div>
    </>
  );
}

export default Header;
